export enum ErrorCategory {
  AUTH = 'AUTH',
  ACCESS = 'ACCESS',
  NETWORK = 'NETWORK',
  SYSTEM = 'SYSTEM'
}
